module.exports = "/assets/be13851b8759f04122fc70b2f41f0102.png";


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/flights/assets/logos/3R.png
// module id = 1018
// module chunks = 0